export default __webpack_public_path__ + "static/media/no_orders.d9bffa0f.svg";